import { useEffect, useRef, useState, useCallback } from 'react';
import { WEBSOCKET_URL } from '../services/api'; 

export default function useOrderSocket(onMessage) {
    const wsRef = useRef(null);
    const [isConnected, setIsConnected] = useState(false);
    const onMessageRef = useRef(onMessage);

    
    useEffect(() => {
        onMessageRef.current = onMessage;
    }, [onMessage]);

    const connect = useCallback(() => {
        if (wsRef.current?.readyState === WebSocket.OPEN) return;

        const ws = new WebSocket(WEBSOCKET_URL);
        wsRef.current = ws;

        ws.onopen = () => {
            console.log('WS Dashboard: Connecté');
            setIsConnected(true);
           
            ws.send(JSON.stringify({
                event: 'subscribe',
                channel: 'admin.orders'
            }));
        };

        ws.onmessage = (event) => {
            try {
                const response = JSON.parse(event.data);
               
                if (response.event?.includes('pusher')) return;

                if (response.event === 'order.updated' || response.event === 'order.created') {
                    const messageData = typeof response.data === 'string' 
                        ? JSON.parse(response.data) 
                        : response.data;

                    if (onMessageRef.current) {
                        onMessageRef.current(messageData);
                    }
                }
            } catch (e) {
                console.error("Erreur parsing WS:", e);
            }
        };

        ws.onclose = () => {
            setIsConnected(false);
            setTimeout(connect, 3000);
        };
    }, []);

    useEffect(() => {
        connect();
        return () => {
            if (wsRef.current) wsRef.current.close();
        };
    }, [connect]);

    return { isConnected };
}